import { gql } from '@apollo/client';

export const limitedNoteOnProject = gql(`
  fragment LimitedNote on ProjectNote {
    id
    rows
    content
    created_at
    updated_at
  }
`);

export const fullNoteOnProject = gql(`
  fragment FullNote on ProjectNote {
    ...LimitedNote
    images {
      id
      url
    }
  }
`);

export const listProjectFragments = gql(`
  fragment ListProject on Project {
    id
    short_id
    name
    craft_type
    is_public
    state
    created_at
    ends_at
    started_at
    updated_at
    image {
      id
      url
    }
    note {
      ...LimitedNote
    }
    pattern {
      id
      name
    }
  }
`);

export const SingleProjectFragment = gql(`
  fragment SingleProject on Project {
    id
    short_id
    is_public
    name
    state
    craft_type
    image {
      id
      url
    }
    started_at
    recipient
    ends_at
    note {
      ...LimitedNote
    }
    projectActivities(limit: $activitiesLimit, cursor: $activitiesCursor, sortOrder: $activitiesSortOrder) {
      activities {
        type
        details {
          ... on ProjectStateChangeDetails {
            from
            to
          }
          ... on ProjectVisibilityChangeDetails {
            is_public
            published_at
          }
        }
        note {
          ...FullNote
        }
        created_at
        updated_at
      }
      limit
      cursor
    }
    projectNotes(limit: $notesLimit, cursor: $notesCursor) {
      notes {
        id
        content
        rows
        images {
          id
          url
        }
        created_at
        updated_at
      }
      limit
      cursor
    }
    pattern {
      id
      name
      craft_type
      image {
        url
        alt
      }
    }
    yarns {
      ...ProjectQuantityYarn
    }
    created_at
    updated_at
  }
`);

export const fullYarnFragment = gql(`
  fragment FullYarn on Yarn {
    id
    name
    color
    content
    note
    location
    brand
    sku
    weight
    yarn_weight
    quantity
    # in_use # NOTE: DO NOT include this out of Project context, as it will always be null and override other queries
    crochet_gauge {
      rows
      stitches
      unit
    }
    image {
      url
      alt
    }
    knitting_gauge {
      rows
      stitches
      unit
    }
    projects {
      id
      name
      in_use
    }
    created_at
    updated_at
  }
`);

export const projectYarnFragment = gql(`
  fragment ProjectQuantityYarn on Yarn {
    id
    name
    in_use
    quantity
  }
`);
